import styled from "styled-components";

import { A } from "core/Typography";
import fonts from "core/fonts";

export const Link = styled(A)`
    text-decoration: none;

    &,
    &:any-link {
        color: ${fonts.fontColors.light.primary};

        &:hover {
            color: ${fonts.fontColors.light.link};
            text-decoration: underline;
        }
    }
`;
